import { ALL_INDUSTRIES, BRANDS } from "./industryData";

// ─── SEARCHABLE INDEX ───
// Flat array of all searchable content items across the site
const buildSearchIndex = () => {
  const items = [];

  // Core pages
  items.push(
    { title: "Home", desc: "Welkom Winder Services - Mining & Industrial Engineering Excellence", url: "/", category: "Pages" },
    { title: "About Us", desc: "25+ years of trusted engineering excellence across Africa since 1999", url: "/about", category: "Pages" },
    { title: "Products & Services", desc: "Comprehensive electrical, mechanical, and mining engineering solutions", url: "/services", category: "Pages" },
    { title: "Our Team", desc: "Meet our experienced team of engineers and technicians", url: "/team", category: "Pages" },
    { title: "Mining Sector Projects", desc: "Engineering projects and active contracts within the Mining Sector", url: "/industries/mining#projects", category: "Pages" },
    { title: "Contact Us", desc: "Get in touch with our team for quotes and enquiries", url: "/contact", category: "Pages" },
  );

  // Industries
  ALL_INDUSTRIES.forEach((ind) => {
    items.push({ title: `${ind.title} Solutions`, desc: ind.heroStatement, url: `/industries/${ind.slug}`, category: "Industries" });

    // Services from each industry
    ind.serviceGroups.forEach((g) => {
      g.items.forEach((svc) => {
        items.push({ title: svc, desc: `${ind.title} - ${g.title}`, url: `/industries/${ind.slug}`, category: "Services" });
      });
    });

    // Products from each industry
    ind.productCategories.forEach((p) => {
      items.push({ title: p.name, desc: p.desc, url: `/industries/${ind.slug}`, category: "Products" });
    });

    // FAQs
    ind.faqs.forEach((f) => {
      items.push({ title: f.q, desc: f.a.substring(0, 120) + "...", url: `/industries/${ind.slug}`, category: "FAQs" });
    });

    // Downloads
    (ind.downloads || []).forEach((d) => {
      items.push({ title: d.name, desc: `${d.type} - ${d.size} - ${d.category}`, url: `/industries/${ind.slug}`, category: "Downloads" });
    });

    // Projects
    ind.projects.forEach((p) => {
      items.push({ title: p.title, desc: p.scope || p.desc || "", url: `/industries/${ind.slug}`, category: "Projects" });
    });
  });

  // Brands
  BRANDS.forEach((b) => {
    items.push({ title: b.name, desc: `${b.desc} - ${b.products}`, url: "/industries/mining", category: "Brands" });
  });

  return items;
};

const SEARCH_INDEX = buildSearchIndex();

// Simple fuzzy search: matches if all query words appear in title+desc
const searchSite = (query) => {
  if (!query || query.length < 2) return [];
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  const scored = SEARCH_INDEX
    .map((item) => {
      const haystack = `${item.title} ${item.desc} ${item.category}`.toLowerCase();
      const titleLower = item.title.toLowerCase();
      let score = 0;
      let allMatch = true;
      for (const w of words) {
        if (!haystack.includes(w)) { allMatch = false; break; }
        if (titleLower.includes(w)) score += 3;
        else score += 1;
      }
      return allMatch ? { ...item, score } : null;
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score);

  // Dedupe by url+title, limit results
  const seen = new Set();
  const unique = [];
  for (const item of scored) {
    const key = `${item.url}|${item.title}`;
    if (!seen.has(key)) { seen.add(key); unique.push(item); }
    if (unique.length >= 20) break;
  }
  return unique;
};

// Group results by category
const groupResults = (results) => {
  const groups = {};
  results.forEach((r) => {
    if (!groups[r.category]) groups[r.category] = [];
    groups[r.category].push(r);
  });
  return groups;
};

export { searchSite, groupResults, SEARCH_INDEX };
